'use client';

import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import React from 'react';
import { SocialIcons } from '@eliadmin/core/src/components/header/social-icons';
import { MdLocalPhone } from 'react-icons/md';

export function CustomTopbar() {
  const generalLayout = useGlobalStore(s => s.generalLayout);

  return (
    <div
      className={cn(
        'flex w-full items-center justify-end font-bold text-white lg:justify-between lg:pl-16 xl:pl-36',
        'ea-social-icons__wrapper',
      )}
    >
      <p className="hidden items-center justify-center gap-2.5 lg:flex">
        Potrebujete poradiť? Zavolajte nám <MdLocalPhone size={20} /> {generalLayout.contact?.phone}
      </p>
      <div className="flex items-center justify-end gap-3 pr-4">
        <span className="border-l pl-4 text-xs font-bold">Sledujte nás</span>
        <SocialIcons className={{ icon: 'h-5 w-5 fill-white stroke-white text-white' }} />
      </div>
    </div>
  );
}
